import './AboutDetails.css'
import React from 'react';

function AboutDetailsMobile() {
    return (
        <div className='about-details-container-mobile p-4 flex flex-col items-start'>
            <div className='mt-8 overflow-y-scroll flex flex-col gap-8'>
                <div className='font-screen-monitor' style={{ fontSize: '15px' }}>
                        Christian Horrer is a designer and art director based in Berlin. For the past four years, he has been working as a multidisciplinary freelance graphic designer, primarily in the fields of music, fashion and culture.<br />
                        Additionally he has been freelancing for the GOAT Group since 2022 regularly.
                        <br /><br />
                        Christian Horrer takes a conceptual and detail- oriented approach that bridges across media and programs while leaving room for experimentation.
                </div>
                <div className='grid grid-cols-2 gap-4 w-full'>
                    <div className='font-semi-bold'>
                        Selected Clients
                        <br /><br />
                        Alias.org<br />
                        Cleptomanicx<br />
                        Disruption DJ<br />
                        Flause Kollektiv Goe<br />
                        Fight Club<br />
                        Goat Group<br />
                        Nulleins Records<br />
                        Sony Music Germany<br />
                        Techno Germany<br />
                        Veit DJ
                    </div>
                    <div className='font-semi-bold'>
                        Features & Publications
                        <br /><br />
                        Blank Poster Volume 1<br />
                        C24 Archive One<br />
                        New Aesthetics 2019<br />
                        Page Mag<br />
                        Saiten Kulturmagazin<br />
                        Tomorrow.type.today
                    </div>
                </div>
                <div className='grid grid-cols-2 gap-4 w-full'>
                    <div className='font-semi-bold self-start'>
                        Education
                        <br /><br />
                        2016 - 2021
                        <br />
                        Communication Design Studies<br />
                        HTWG Constance, Germany<br />
                        2012-2015<br />
                        Apprenticeship Graphic Design Assistent<br /><br /><br />
                        Work Experience in Design
                        <br /><br />
                        2021 - now<br />
                        Full Time Freelance<br />
                        2019 - 2020<br />
                        Volunteer for KD—Lounge Lecture Series<br />
                        2019<br />
                        Internship at Deutsche & Japaner
                    </div>
                    <div className='font-semi-bold self-start'>
                        Exhibitons<br /><br />
                        2019 - 2021<br />
                        Part of the Werkschau every Semester<br />
                        HTWG Constance, Germany<br /><br />
                        Typojanchi 2019<br />
                        6th International Typography Biennale<br /><br />
                        Captcha 2019
                        <br /><br /><br />
                        Awards
                        <br /><br />
                        Konstanzer Designpreis
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AboutDetailsMobile;
